module.exports = __webpack_public_path__ + "static/media/UIChatRoom-profil2.c8df7ff2.png";